import React from 'react'
import PropTypes from 'prop-types'
import {
  ContentSetWrapper,
  StyledContentTypeDescription,
} from './component.styles'
import { contentfulImageShape } from 'utils/shapes'
import { createShutterList } from './utils'

const ShutterList = ({
  className,
  contentDescription,
  items = [],
  renderItem,
  trainingCallout,
  renderContentDescription,
  queryParams = '',
}) => {
  return (
    <ContentSetWrapper
      className={className}
      hasFooter={contentDescription?.hasFooter}
    >
      {contentDescription &&
        (renderContentDescription ? (
          renderContentDescription(contentDescription)
        ) : (
          <StyledContentTypeDescription {...contentDescription} />
        ))}
      {trainingCallout && renderItem && (
        <React.Fragment>
          {renderItem({
            ...trainingCallout,
            path: trainingCallout.route,
          })}
        </React.Fragment>
      )}
      {items
        ?.filter(item => !!item.description && !!item.title && !!item.path)
        .map((item, i) => (
          <React.Fragment key={i}>
            {renderItem?.({
              ...item,
              path: `${item.path}${queryParams}`,
            })}
          </React.Fragment>
        ))}
    </ContentSetWrapper>
  )
}

ShutterList.propTypes = {
  className: PropTypes.string,
  contentDescription: PropTypes.shape({
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    body: PropTypes.string,
    bodyColor: PropTypes.string,
    borderColor: PropTypes.string,
    dataTestId: PropTypes.string,
    descriptionImage: contentfulImageShape,
    descriptionPdf: PropTypes.array,
    footerChildren: PropTypes.node,
    hasFooter: PropTypes.bool,
    id: PropTypes.string,
    singleLink: PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      color: PropTypes.string,
      hoverColor: PropTypes.string,
    }),
    title: PropTypes.string,
    titleColor: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
  queryParams: PropTypes.string,
  renderContentDescription: PropTypes.func,
  renderItem: PropTypes.func,
  trainingCallout: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    route: PropTypes.string,
  }),
}

export default ShutterList

export { createShutterList }
